// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"1c7edd42bb041e5bd1fb","883":"65c2eb5b2fba8224d22e"}[chunkId] + ".js";
};